<div *ngIf="commonService.supplierRole" class="not-authorized-message">
  {{commonService.Notautorized}}
</div>
<div *ngIf="!commonService.supplierRole">
<div class="col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
  <section id="Noprop" class="col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-0 section-no-margin-bottom">
    <div class="d-flex align-items-center m-0 pb-1">
      <div class="col-4 pl-0"></div>
      <div class="center col-4 text-center"> <img src="assets/images/RG_RENAULT_GROUP_LOGOTYPE_BLACK_RGB_v21_1.png"
          class="logo-image" alt="edit"></div>

      <div class="col-4 text-right">
        <div> <app-helpsection></app-helpsection></div>

      </div>
    </div>
  </section>

  <section class="col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-0">
    <app-suppliertab></app-suppliertab>
    <div class="row m-0 align-center">
      <div class="col-order-1 col-order-height">
        <button class="btn btn-darkred btn-custom px-4 mr-2 btn-margin-left" type="button"
          (click)="openPortfolioList()" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (openPortfolioList())">
          Portfolio
        </button>&nbsp;&nbsp;
        <button class="btn btn-darkred btn-custom px-4 mr-2" type="button" data-toggle="modal"
          data-target="#activitySelect" *ngIf="superUserShow" (click)="getSupplierActivity()">
          Check GUO
        </button>&nbsp;&nbsp;
        <button class="btn btn-darkred btn-custom px-4 mr-2" type="button" data-toggle="modal"
          data-target="#openFactoriesModal">
          Check Company Name
        </button>&nbsp;&nbsp;
      </div>
    </div>
  </section>

  <section class="col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-0" *ngIf="showResultsCheckGUO==true">
    <div class="row m-0 pt-3 align-center">
      <div class="col col-12 col-sm-9 col-md-10 col-lg-10 col-xl-10">
        <h4 class="title">RESULTS <span *ngIf="loadData==false">(0)</span><span
            *ngIf="loadData==true && bvdIddata && bvdIddata.length>=0">({{bvdIds.length}})</span><span
            *ngIf="loadData==true && bvdIddata && bvdIddata.length>=0" class="titleSubText1">Selected Company: </span>
          <span *ngIf="loadData==true && bvdIddata && bvdIddata.length>=0" class="titleSubText label-darkblue">
            {{AvalueSelected[0]}}</span>
        </h4>
      </div>

      <div class="col col-12 col-sm-3 col-md-2 col-lg-2 col-xl-2">
        <button type="button" class="btn btn-custom btn-custom-lg btn-blue float-right d-flex align-center"
          *ngIf="superUserShow">
          <mat-icon svgIcon="download" class="thick-icon export-icon-size"></mat-icon> <span class="float-right"> Export </span>
        </button>
      </div>
    </div>

    <div class="row m-0">
      <div class="table-responsive mt-3">
        <div [ngClass]="{ 'fixTableHead' :loadData == true,'fixTableFoot' :loadData == true}">
          <table class="table table-sm m-0">
            <thead>
              <tr>
                <th class="sortDecorationunderline th-text-left">Bvd ID</th>
                <th class="sortDecorationunderline th-text-left">Supplier Name</th>
                <th class="sortDecorationunderline th-text-left">GUO in Orbis</th>
                <th class="sortDecorationunderline th-text-left">GUO in ISA</th>
                <th class="th-width-10"></th>
              </tr>
            </thead>

            <tbody *ngIf="bvdIddata.length>=0" #customLoadingTemplate>
              <tr *ngFor="let cmData of orbisIdData;let i=index">
                <td>{{cmData.oldBvdId ? cmData.oldBvdId : cmData.BVD_ID_NUMBER ? cmData.BVD_ID_NUMBER : ''}}</td>
                <td>{{cmData ? cmData.NAME : ''}}</td>
                <td>
                  <p class="mb-2">{{cmData.GUO_NAME ? cmData.GUO_NAME : cmData.NAME}}</p>
                  <p class="mb-2">
                    <span class="font-weight-bold">{{cmData ? (cmData.GUO_BVD_ID_NUMBER ? cmData.GUO_BVD_ID_NUMBER[0] :
                      cmData.BVD_ID_NUMBER) : cmData.BVD_ID_NUMBER}}
                    </span>
                  </p>
                  <p class="mb-2" *ngIf="cmData['ADDRESS_LINE1']">
                    <span class="mb-2">{{cmData['ADDRESS_LINE1'] ? cmData['ADDRESS_LINE1'] : ''}}</span>
                  </p>
                  <p class="mb-2" *ngIf="cmData['ADDRESS_LINE2']"> <span class="pl-1" id="bold1"
                      *ngIf="cmData['ADDRESS_LINE2']"> {{cmData['ADDRESS_LINE2'] ? cmData['ADDRESS_LINE2'] : ''}}</span>
                  </p>
                  <p class="mb-2" *ngIf="cmData['ADDRESS_LINE3']"> <span class="pl-1" id="bold2"
                      *ngIf="cmData['ADDRESS_LINE3']"> {{cmData['ADDRESS_LINE3'] ? cmData['ADDRESS_LINE3'] : ''}}</span>
                  </p>
                  <p class="mb-2" *ngIf="cmData['POSTCODE'] || cmData['CITY'] || cmData['CITY_STANDARDIZED']">
                    <span class="mb-2" id="bold3">
                      {{cmData['POSTCODE'] ? cmData['POSTCODE'] : ''}}
                      &nbsp;{{this.commonService.hasNoSpecialCharacters(cmData['CITY_STANDARDIZED'],cmData['CITY'])}}
                    </span>
                  </p>
                  <p class="mb-2">{{cmData ? cmData.COUNTRY: ''}}</p>
                </td>
                <td *ngIf="cmData.grpname">
                  <p class="mb-2">{{cmData.additionalInformation=="" || cmData.additionalInformation ? (cmData.grpname ?
                    cmData.grpname : '' ): ''}}</p>
                  <p class="mb-2">
                    <span class="font-weight-bold">{{(cmData.additionalInformation=="" || cmData.additionalInformation)
                      ? (cmData.GUO_BVD_ID_NUMBER ? cmData.GUO_BVD_ID_NUMBER[0] : cmData.BVD_ID_NUMBER) : ''}}
                    </span>
                  </p>
                  <p class="mb-2"
                    *ngIf="(cmData.wayNumber !='' && cmData.wayNumber != undefined) ||
                      (cmData.streetName !='' && cmData.streetName != undefined)">
                    <span class="mb-2" id="bold4">{{cmData.wayNumber}} {{cmData.streetName}}</span>
                  </p>
                  <p class="pl-1 mb-2"
                    *ngIf="cmData.additionalInformation !='' && cmData.additionalInformation != undefined">
                    {{cmData.additionalInformation}}
                  </p>
                  <p class="pl-1 mb-2"
                    *ngIf="(cmData.postalCode !='' && cmData.postalCode != undefined) ||
                      (cmData.cityName !='' && cmData.cityName != undefined)">
                    {{cmData.postalCode}} &nbsp; {{cmData.cityName}}
                  </p>
                  <p class="pl-1 mb-2"
                    *ngIf="cmData.territorialDivision !='' && cmData.territorialDivision != undefined">
                    {{cmData.territorialDivision}}
                  </p>
                  <p class="pl-1 mb-2">{{cmData ? (cmData['countryName'] ? cmData['countryName'] : '') : ''}}</p>
                </td>
                <td><img src="assets/images/green-check1.png" alt="GUO check confirmed"
                    *ngIf="cmData.GUOinISACheck==true"></td>
              </tr>
            </tbody>

            <tbody *ngIf="message" #customLoadingTemplate>
              <tr>
                <td colspan="8" class="font-weight-bold label-darkblue text-center"> No Results</td>
              </tr>
            </tbody>

            <tfoot *ngIf="selectedBvd && selectedBvd.length>0 && PageTotalLength>20">
              <tr>
                <td colspan="8">
                  <ul *ngIf="pager.pages && pager.pages.length" class="pagination">
                    <li [ngClass]="{disabled:pager.currentPage === 1}">
                      <a (click)="getPagerForCheckGuo(1)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (getPagerForCheckGuo(1))">First</a>
                    </li>
                    <li [ngClass]="{disabled:pager.currentPage === 1}">
                      <a (click)="getPagerForCheckGuo(pager.currentPage - 1)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (getPagerForCheckGuo(pager.currentPage - 1))">Previous</a>
                    </li>
                    <li *ngFor="let page of pager.pages" [ngClass]="{active:pager.currentPage === page}">
                      <a (click)="getPagerForCheckGuo(page)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (getPagerForCheckGuo(page))">{{page}}</a>
                    </li>
                    <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                      <a (click)="getPagerForCheckGuo(pager.currentPage + 1)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (getPagerForCheckGuo(pager.currentPage + 1))">Next</a>
                    </li>
                    <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                      <a (click)="getPagerForCheckGuo(pager.totalPages)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (getPagerForCheckGuo(pager.totalPages))">Last</a>
                    </li>
                  </ul>
                </td>
              </tr>
            </tfoot>
            <ng-container *ngIf="loading">
              <div class="local-loading-overlay">
                <div class="custom-spinner-template">
                  <mat-spinner class="custom-spinner black-spinner" diameter="40"></mat-spinner>
                </div>
              </div>
            </ng-container>
            <div *ngIf="orbisBvdDataLoading == true && orbisIdData.length != PageTotalLength"
              class="loading-container loading-container-center">
              <img src="assets/images/loading.gif" alt="loading...">
            </div>
          </table>
        </div>
      </div>
    </div>
  </section>

  <section class="col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-0" *ngIf="showResultsPortfolio==true">
    <div class="row m-0 pt-3 align-center">
      <div class="col col-12 col-sm-7 col-md-5 col-lg-5 col-xl-5">
        <h4 class="title">RESULTS <span
            *ngIf="loadPortfolioData==true && portfolioList && portfolioList.length>=0">({{PageTotalLength}})</span>
        </h4>
      </div>

      <div class="col col-12 col-sm-5 col-md-7 col-lg-7 col-xl-7 text-right">
        <button type="button" class="btn btn-custom btn-custom-lg btn-blue mr-2 btn-height-42"
          *ngIf="superUserShow" (click)="loadTheValues('remove')" data-target="#openAddOrRemoveBvdModal"
          data-toggle="modal" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (loadTheValues('remove'))">
          Remove from Portfolio
        </button>
        <button type="button" class="btn btn-custom btn-custom-lg btn-blue mr-2 btn-height-42"
          *ngIf="superUserShow" (click)="loadTheValues('add')" data-target="#openAddOrRemoveBvdModal"
          data-toggle="modal">
          <span class="float-right">Import in Portfolio</span>
        </button>
        <button type="button" class="btn btn-custom btn-custom-lg btn-blue btn-height-42" *ngIf="superUserShow"
          (click)="ExportportfolioToExcel()" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (ExportportfolioToExcel())">
          <mat-icon svgIcon="download" class="thick-icon export-icon-size"></mat-icon>
          <span class="float-right"> Export Portfolio </span>
        </button>
      </div>
    </div>

  </section>
</div>

<div class="modal fade" id="openCheckguo" tabindex="-1" aria-modal="true" aria-labelledby="exampleModalLabel"
 >
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel">
          Start Date
          <button type="button" class="close" id="closeCheckguo" #closeBtn data-dismiss="modal" aria-label="Close">
            <span>&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <input type="radio" class="form-check-input m-0 radio-input-large"
              name="checkGuoStartDate" value="1 week" id="startDateOneWeek" [(ngModel)]="checkGuoStartDate">
            <label class="label-control m-0 px-4" for="startDateOneWeek">1 Week ago</label><br>
            <input type="radio" class="form-check-input m-0 radio-input-large"
              name="checkGuoStartDate" value="2 week" id="startDateTwoWeek" [(ngModel)]="checkGuoStartDate">
            <label class="label-control m-0 px-4" for="startDateTwoWeek">2 Weeks ago</label><br>
            <input type="radio" class="form-check-input m-0 radio-input-large"
              name="checkGuoStartDate" value="1 month" id="startDateOneMonth" [(ngModel)]="checkGuoStartDate">
            <label class="label-control m-0 px-4" for="startDateOneMonth">1 Month ago</label><br>
            <input type="radio" class="form-check-input m-0 radio-input-large"
              name="checkGuoStartDate" value="3 month" id="startDateThreeMonth" [(ngModel)]="checkGuoStartDate">
            <label class="label-control m-0 px-4" for="startDateThreeMonth">3 Months ago</label><br>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0 row text-right">
        <section class="bg-white no-shadow col m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
          <button type="button" class="btn btn-custom btn-custom-md btn-blue" [disabled]="disableCheckGuo"
            (click)="LoadGuo()" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (LoadGuo())">
            OK
          </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade mt-4" id="activitySelect" tabindex="-1" aria-modal="true" aria-labelledby="exampleModalLabel"
 >
  <div class="modal-dialog modal-custom" >
    <div class="modal-content modal-content-custom-width">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel1">
          Company Selection
          <button type="button" class="close" id="closeEditActivity" #closeBtn data-dismiss="modal" aria-label="Close">
            <span>&times;</span>
          </button>
        </h6>
      </div>
      <div *ngIf="activityLoaded" class="col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 section-scroll">
        <div class="row m-0 pt-5">
          <div class="activity-container">
            <div class="label-control fontBold pb-2 weight-font"> A</div>
            <ng-container *ngIf="optActivityA">
              <div class="activity-item" *ngFor="let valueA of optActivityA">
                <input type="radio" name="radioGroup" [value]="valueA" [ngModel]="selectedValue"
                  [id]="'radioGroup-' + valueA.value" (change)="getSelectedValue(valueA)">
                <label [for]="'radioGroup-' + valueA.value">{{valueA.value}}</label>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
      <div *ngIf="!activityLoaded" class="text-center">
        <img src="assets/images/loading.gif" alt="loading...">
      </div>
      <div class="modal-footer border-0 row">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="openPortfolioList('orbis')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (openPortfolioList('orbis'))">
            <mat-icon svgIcon="mail" class="img-btn mr-2 icon-white-small"></mat-icon>
            <span class="float-right padding-top-small">Save</span>
          </button>
        </section>
      </div>
    </div>
  </div>
</div>
<div class="modal fade" id="openAddOrRemoveBvdModal" tabindex="-1" aria-modal="true" aria-labelledby="exampleModalLabel"
 >
  <div class="modal-dialog modal-custom">
    <div class="modal-content modal-content-offset-small">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel2">
          BvD ID File
          <button type="button" class="close" id="closeAddOrRemoveBvdModal" #closeBtn data-dismiss="modal"
            aria-label="Close">
            <span>&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <label for="file" class="label-control font-weight-bold label-display-block">Upload TXT File <span
                class="element_astrick">*</span></label>
            <input #inputUpload id="file" (change)="changeListener($event)" type="file" accept=".txt" />
          </div>
          <span class="error-text" *ngIf="selectFileError==true">Please select a File!!!</span>
          <span class="error-text" *ngIf="uploadDocError==true">Upload file error</span>
          <span class="error-text" *ngIf="uploadDocError1==true">Only TXT files are accepted</span>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0" *ngIf="importIsOn==true">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" [disabled]="disableUploadBtn==true"
            (click)="importClickFunction('add')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (importClickFunction('add'))">
            Import
          </button>
        </section>
        <section class="bg-white no-shadow m-0" *ngIf="importIsOn==false">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" [disabled]="disableUploadBtn==true"
            (click)="importClickFunction('remove')">
            Remove
          </button>
        </section>
      </div>
    </div>
  </div>
</div>
</div>